import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../environments/environment.prod';
/**
 * Servicio que se encarga de todas las notificaciones
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  /**
   * Constructor
   *
   * @param http modulo de peticiones http
   */
  constructor(
    private http: HttpClient
  ) { }

  /**
   * Envia un correo electronico
   *
   * @param email correo electronico
   * @param text texto del mensaje
   * @param subject asunto del correo
   * @param html html del correo
   */
  sendEmail(email: string, text: string, subject: string, html?: string): Observable<any> {
    const body = {
      dst: email,
      subject,
      text,
      html
    };
    return this.http.post(`${environment.apiUrl}/send-email`, body);
  }
}
